import { useEffect, useState } from 'react';
import { StoryScene } from '@/components/game/StoryScene';
import { entrarAEscena, escenaRequerida } from '@/engine/narrative';
import { inicializarContenido, ESCENA_INICIAL } from '@/content';
import { useNarrativeStore } from '@/engine/state';
import type { Scene } from '@/types';

export function StoryPage() {
  const sceneIdActual = useNarrativeStore((s) => s.sceneIdActual);
  const [scene, setScene] = useState<Scene | null>(null);

  useEffect(() => {
    inicializarContenido();
    const id = sceneIdActual ?? ESCENA_INICIAL;
    const s = sceneIdActual === null ? entrarAEscena(id) : escenaRequerida(id);
    setScene(s);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!sceneIdActual) return;
    try {
      setScene(escenaRequerida(sceneIdActual));
    } catch {
      setScene(entrarAEscena(ESCENA_INICIAL));
    }
  }, [sceneIdActual]);

  if (!scene) {
    return (
      <div className="h-full w-full flex items-center justify-center text-ash-500 font-ui uppercase tracking-widest fluid-xs animate-pulse">
        cargando escena…
      </div>
    );
  }

  return (
    <div className="h-full w-full">
      <StoryScene scene={scene} />
    </div>
  );
}
